<template>
  <div>
    <div class="d-flex justify-space-between">
      <div class="text-h4 mb-0 d-flex align-center">
        Print Orders
        <v-btn
          outlined
          small
          icon
          class="ml-3"
          min-width="20"
          :loading="loading"
          @click="loadData"
        >
          <v-icon small> refresh </v-icon>
        </v-btn>
      </div>
      <div v-if="selected_jobs.length" class="d-flex align-center">
        <v-checkbox
          v-model="sandboxMode"
          label="4Over Sandbox"
          class="mr-4 mt-0 pt-0"
          hide-details
          dense
        />
        <v-btn
          :loading="submitting"
          elevation="0"
          @click="submitPrints"
        >
          <v-icon class="mr-1"> mdi-send-outline </v-icon>
          Submit Prints ({{ selected_jobs.length }})
          <span v-if="sandboxMode" class="ml-1">(SANDBOX)</span>
        </v-btn>
      </div>
    </div>
    <v-row class="mt-0 mb-5">
      <v-col class="pt-0">
        <v-chip label>
          <span class="font-weight-bold">30 Days:</span>&nbsp; Rev:
          {{ queue.monthRevenue | currency }} | Mark: {{ queue.monthMarkup | percentage }} | Marg:
          {{ queue.monthMargin | percentage }}
        </v-chip>
      </v-col>
    </v-row>
    <PrintList
      :loading="loading"
      :data="pendingJobs"
      title="Pending Jobs"
    />
    <PrintList
      :loading="loading"
      :data="pausedJobs"
      title="Paused Jobs"
      paused
    />
  </div>
</template>

<script>
import PrintList from '@/components/orders/print/List';
import { mapGetters } from 'vuex';

export default {
  name: 'OrdersQueue',

  components: { PrintList },

  data() {
    return { loading: false, submitting: false, sandboxMode: false };
  },

  computed: {
    pendingJobs() {
      return (this.queue?.pendingJobs || []).concat(this.queue?.pendingPromoJobs || []);
    },
    pausedJobs() {
      return (this.queue?.pausedJobs || []).concat(this.queue?.pausedPromoJobs || []);
    },
    ...mapGetters({
      queue: 'orders/queue',
      selected_jobs: 'orders/selected_jobs'
    })
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('orders/getQueue')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    submitPrints() {
      this.submitting = true;
      this.$store
        .dispatch('orders/submitJobs', {
          printJobIds: this.selected_jobs.filter((x) => !x.isPromo).map((x) => x.jobId),
          promoJobIds: this.selected_jobs.filter((x) => x.isPromo).map((x) => x.jobId),
          sandboxMode: this.sandboxMode
        })
        .then((response) => {
          if (this.sandboxMode && response) {
            response.forEach((result, i) => {
              console.log(`=== 4Over SANDBOX [${i + 1}/${response.length}] ===`);
              console.log('--- Payload ---');
              console.log(JSON.stringify(result.payload, null, 2));
              console.log('--- Response ---');
              console.log(JSON.stringify(result.response, null, 2));
            });
          }
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
